export abstract class BaseConverter<Model, Dto> {

    abstract modelToDto(model: Model): Dto;

    abstract dtoToModel(dto: Dto): Model;

    modelsToDtos(models: Model[]): Dto[] {
        return models.map(model => this.modelToDto(model));
    }

    dtosToModels(dtos: Dto[]): Model[] {
        return dtos.map(dto => this.dtoToModel(dto));
    }


}